import { type JssStyle } from 'jss';

import {
    EButtonStyleType,
    EFontStyle,
    ELineStyle,
    ESize,
    ETestimonialCount,
    ETestimonialLayout,
    ETestimonialType,
    Widgets,
} from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { type WebWidgetModel } from '@web/types';
import { type TestimonialWidgetData } from '@web/widgets/testimonial/type/testimonial-widget.type';
import { TestimonialViewComponent } from '@web/widgets/testimonial/components/testimonial-view/testimonial-view.component';
import { TestimonialControlComponent } from '@web/widgets/testimonial/components/testimonial-control/testimonial-control.component';
import {
    DEFAULT_BUTTON_BASE,
    DEFAULT_BUTTON_HOVER_STATES,
} from '@web/widgets/common/base/base-button/base-button.const';

// DEFAULT COMPONENT SETTINGS
const testimonialData: TestimonialWidgetData = {
    layout: ETestimonialLayout.carousel,
    testimonialCount: ETestimonialCount.all,
    selectedCourseId: null,
    items: [],
    settings: {
        rowItems: 3,
        spaceBetween: 20,
        isShortText: false,
        isShowMore: false,
        buttonColor: '#333',
        isAutoScroll: true,
        type: ETestimonialType.noAvatar,
        linkText: 'Show full text',
        linkColor: '#333',
        fontSize: 16,
        fontStyle: EFontStyle.AT,
        fontColor: '#333',
        backgroundColor: '#ffffff',
        isBorder: false,
        borderWidth: 1,
        borderStyle: ELineStyle.SOLID,
        borderColor: '#000',
        isShadow: false,
        rounding: 0,
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 15,
        paddingRight: 15,
    },
    buttonSettings: {
        label: 'Show more',
        styleType: EButtonStyleType.primary,
        size: ESize.M,
        buttonBase: { ...DEFAULT_BUTTON_BASE },
        buttonHover: { ...DEFAULT_BUTTON_HOVER_STATES },
    },
};

const testimonialStyles: JssStyle = {};
// END DEFAULT SETTINGS

export const testimonialWidgetModel: WebWidgetModel = {
    componentView: TestimonialViewComponent,
    componentControl: TestimonialControlComponent,
    name: Widgets.TESTIMONIAL,
    label: 'widget_testimonial_label',
    data: testimonialData,
    styles: testimonialStyles,
    permission: defaultWidgetPermission,
    params: {
        ...defaultWidgetParams,
        isEducation: true,
        disabledTooltip: 'testimonial_pricing_plan',
    },
};
